module.exports = __webpack_public_path__ + "static/media/koala-favicon.b8ff72b5.png";